<template>
  <div class="promForm">
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-link @click="explain = true" style="margin-right: 10px" icon="el-icon-question" :underline="false"
          type="warning">操作说明</el-link>
      </template>
    </page-header>

    <el-scrollbar style="height: calc(100% - 50px)">
      <div style="height: 20px"></div>
      <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="120px">
        <el-divider>活动基本信息</el-divider>
        <div class="form-item-wrap">
          <el-form-item label="活动类型" prop="type">
            <el-select :disabled="submitType == 'Update'" v-model="addForm.type" placeholder="请选择" style="width: 200px"
              @change="onTypeSelectChange">
              <!-- $store.state.PROM_TYPE -->
              <el-option v-for="item in promtype" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="活动标题" prop="title">
            <el-input v-model="addForm.title" style="width: 200px" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="促销描述" prop="describe">
            <el-input v-model="addForm.describe" style="width: 200px" placeholder="将会显示在商品详情界面"></el-input>
            <el-tooltip class="item" effect="dark" content="将会显示在商品详情和购物车界面" placement="right">
              <i class="el-icon-question form-item-tips"></i>
            </el-tooltip>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="开始时间" prop="startTime">
            <el-date-picker v-model="addForm.startTime" style="width: 200px" type="datetime"
              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker v-model="addForm.endTime" style="width: 200px" type="datetime" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
        </div>

        <el-divider>活动商品</el-divider>
        <div class="form-item-wrap">
          <el-form-item label="选择商品" prop="coverage">
            <el-select :disabled="coverageDisabled" v-model="addForm.coverage" placeholder="活动类型"
              style="width: 200px; margin-right: 10px" @change="onCoverageSelectChange">
              <el-option v-for="item in coverageList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <!-- 如果是独立商品的话，选择一个后禁用 -->
            <el-button v-if="addForm.coverage == 'G01'" :disabled="
                addForm.coverage == 'G01' && addForm.list.length >= 1 && !isQG
              " type="primary" icon="el-icon-circle-plus-outline" @click="handleChoose">添加商品</el-button>
            <el-button v-else-if="addForm.coverage == 'G02'" type="primary" icon="el-icon-circle-plus-outline"
              @click="handleChoose">添加分组</el-button>
            <el-button v-else-if="addForm.coverage == 'G03'" type="primary" icon="el-icon-circle-plus-outline"
              @click="handleChoose">添加品牌</el-button>
            <el-button v-else-if="addForm.coverage == 'G05'" type="primary" icon="el-icon-circle-plus-outline"
              @click="handleChoose">添加商品</el-button>
          </el-form-item>
        </div>
        <!-- 选中的商品范围 -->
        <!-- 全部商品则不显示表格 -->
        <div v-if="addForm.coverage != 'G04'" class="form-item-wrap"
          style="padding: 0 20px; position: relative; overflow: hidden">
          <!-- v-if="addForm.coverage == 'G01'" -->
          <el-form-item>
            <!-- 独立商品列表 -->
            <el-table :data="addForm.list" stripe border tooltip-effect="dark">
              <el-table-column label="序号" align="center" width="95" type="index">
              </el-table-column>

              <!-- 选择不同的商品范围类型不一样，所以这里做了一个判断 -->
              <el-table-column v-if="addForm.coverage == 'G02'" prop="title" align="center" show-overflow-tooltip
                label="分组名称">
              </el-table-column>
              <el-table-column v-else-if="addForm.coverage == 'G03'" prop="title" align="center" show-overflow-tooltip
                label="品牌名称">
              </el-table-column>
              <el-table-column v-else prop="title" align="center" show-overflow-tooltip label="商品名称">
              </el-table-column>

              <!-- <el-table-column prop="discount" align="center" label="折扣">
                        <template slot-scope="scope">
                          <div>
                            <el-input-number v-model="scope.row.discount" :min="1" :max="100"
                              :precision="0"></el-input-number>
                          </div>
                        </template>
                      </el-table-column> -->
              <!-- <el-table-column prop="fullNum" align="center" label="满足数量">
                        <template slot-scope="scope">
                          <div>
                            <el-input-number v-model="scope.row.fullNum" :min="1" :precision="0"></el-input-number>
                          </div>
                        </template>
                      </el-table-column> -->
              <!-- 商品范围是单个商品的显示 -->
              <div v-if="addForm.coverage == 'G01'">
                <el-table-column prop="quantity" align="center" :label="'活动' + Tyname">
                  <template slot-scope="scope">
                    <div>
                      <el-input-number v-model="scope.row.totalQuantity" :min="1" :max="100000000"
                        :precision="0"></el-input-number>
                    </div>
                  </template>
                </el-table-column>
              </div>
              <!-- 如果是组合活动并且商品范围是组合商品可以单独设置商品数量，抢购的商品可以设置起购数量 -->
              <el-table-column v-if="
                  (isZH && addForm.coverage == 'G05') ||
                  isQG ||
                  addForm.coverage == 'G05'
                " prop="quantity" align="center" :label="'起购' + Tyname">
                <template slot-scope="scope">
                  <div>
                    <el-input-number v-model="scope.row.quantity" :min="1" :max="100000000"
                      :precision="0"></el-input-number>
                  </div>
                </template>
              </el-table-column>

              <!-- 其他的类型的活动商品范围非组合活动显示数量设置 -->
              <!-- <el-table-column v-else-if="addForm.coverage != 'G05'" prop="quantity" align="center" label="总数量">
                <template slot-scope="scope">
                  <div>
                    <el-input-number v-model="scope.row.quantity" :min="1" :max="100000000"
                      :precision="0"></el-input-number>
                  </div>
                </template>
              </el-table-column> -->

              <!-- 单个商品限购数量、组合不显示 -->
              <el-table-column v-if="
                  (!isZH && addForm.coverage == 'G05') ||
                  addForm.coverage == 'G01'
                " prop="limitNum" align="center" :label="'限购' + Tyname">
                <template slot-scope="scope">
                  <div>
                    <el-input-number v-model="scope.row.limitNum" :min="0" :precision="0"></el-input-number>
                  </div>
                </template>
              </el-table-column>
              <!-- !isZH -->
              <!-- <div v-if="!isZH && addForm.coverage !== 'G05'">
                <el-table-column
                  v-if="
                    ((!isZH && addForm.coverage == 'G05') ||
                      addForm.coverage == 'G01') &&
                    addForm.mode !== 'M01'
                  "
                  prop="limitNum"
                  align="center"
                  label="限购数量"
                >
                  <template slot-scope="scope">
                    <div>
                      <el-input-number
                        v-model="scope.row.limitNum"
                        :min="0"
                        :precision="0"
                      ></el-input-number>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-else
                  prop="limitNum"
                  align="center"
                  label="限购金额"
                >
                  <template slot-scope="scope">
                    <div>
                      <el-input-number
                        v-model="scope.row.limitNum"
                        :min="0"
                        :precision="0"
                      ></el-input-number>
                    </div>
                  </template>
                </el-table-column>
              </div> -->
              <!-- 促销商品的价格 -->
              <el-table-column v-if="isZH || isQG" prop="price" align="center" label="活动价格">
                <template slot-scope="scope">
                  <div>
                    <el-input-number v-model="scope.row.price" :min="0" :max="100000000"
                      :precision="2"></el-input-number>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                  <el-button type="danger" style="padding: 2px 3px" plain @click="handleDelGoods(scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>

        <el-divider v-if="!isQG">促销满足条件</el-divider>
        <!-- 商品范围是组合商品的时候显示 -->
        <!-- 之前的判断条件 isZH ||  -->
        <div class="form-item-wrap" v-if="addForm.coverage == 'G05' && !isGHG">
          <!-- 组合活动显示 -->
          <el-form-item label="商品总组数" prop="totalQuantity">
            <el-input-number v-model="addForm.totalQuantity" :min="1" :max="100000000" :precision="0"></el-input-number>
          </el-form-item>
          <el-form-item label="限购组数" prop="limitQuantity">
            <el-input-number v-model="addForm.limitQuantity" :min="0" :max="100000000" :precision="0"></el-input-number>
          </el-form-item>
        </div>

        <div class="form-item-wrap" v-if="!isQG">
          <!-- 这个prop使用了mode字段，是因为想让星号显示在前面 -->
          <el-form-item v-if="!isZH" label="促销规则" prop="mode">
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAddRule">添加规则</el-button>
          </el-form-item>
          <div class="form-item-wrap">
            <!-- 除了抢购和组合显示 -->
            <el-form-item v-if="!isZH" label="满足模式">
              <el-select v-model="addForm.mode" placeholder="请选择" style="width: 200px" @change="onModeSelectChange">
                <!-- <el-option v-for="item in modeList" :key="item.value" :label="item.label" :value="item.value"></el-option> -->
                <!-- 这个地方应该需要做判断，所以数据没有放在data里面 -->
                <el-option label="满足金额" value="M01"></el-option>
                <el-option label="满足数量" value="M02"></el-option>
                <!-- 只有折扣活动并且是独立商品可以选择 -->
                <el-option v-show="isMJ && addForm.coverage == 'G01'" label="满足数量减单价" value="M03"></el-option>
              </el-select>
            </el-form-item>
            <!-- 满减、满赠、换购显示是否累加 -->
            <el-form-item v-show="isMJ || isMZ || isHG" label="是否累加" prop="isAdd">
              <div style="width: 200px">
                <el-radio-group v-model="addForm.isAdd">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </div>
        </div>

        <!-- 除了组合、抢购之外的活动显示 -->
        <div class="form-item-wrap" v-if="!isZH && !isQG">
          <el-form-item label="" props="rules">
            <el-table ref="rulesTable" :data="addForm.rules" stripe border tooltip-effect="dark">
              <el-table-column label="序号" align="center" width="95" type="index">
              </el-table-column>
              <!-- 买赠和换购显示 -->
              <el-table-column v-if="isMZ || isHG || isGHG" type="expand" key="expand" label="赠品" width="50">
                <template slot-scope="scope">
                  <!-- v-if放在el-table-column标签上不可用 -->
                  <div>
                    <el-table :data="scope.row.giftList" stripe border tooltip-effect="dark">
                      <el-table-column label="序号" align="center" width="95" type="index">
                      </el-table-column>

                      <el-table-column prop="goodsname" align="center" show-overflow-tooltip label="商品名称">
                      </el-table-column>
                      <el-table-column prop="price" align="center" label="价格">
                        <template slot-scope="scope2">
                          <div>
                            <el-input-number v-model="scope2.row.price" :min="0" :disabled="addForm.type == 'DMZ'"
                              :max="100000000" :precision="2"></el-input-number>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="quantity" align="center" label="总数量">
                        <template slot-scope="scope2">
                          <div>
                            <el-input-number v-model="scope2.row.num" :min="1" :max="scope2.row.quantity"
                              :precision="0"></el-input-number>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column label="操作" align="center" width="100">
                        <template slot-scope="scope2">
                          <el-button type="danger" style="padding: 2px 3px" plain
                            @click="handleDelGift(scope, scope2)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="text-align: center">
                      <el-button type="text" icon="el-icon-circle-plus-outline"
                        @click="handleChooseGift(scope)">添加赠品</el-button>
                    </div>
                  </div>
                  <!-- <span v-else>当前活动不可用</span> -->
                </template>
              </el-table-column>

              <!-- 满足金额或者满足数量 -->
              <el-table-column v-if="addForm.mode == 'M01'" prop="price" align="center" label="满足金额">
                <template slot-scope="scope">
                  <div>
                    <!-- 这个地方价格为0是因为有的不需要填写价格 -->
                    <el-input-number v-model="scope.row.condition" :min="0" :max="100000000"
                      :precision="2"></el-input-number>
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-else-if="
                  addForm.mode == 'M02' || (isMJ && addForm.coverage == 'G01')
                " prop="price" align="center" label="满足数量">
                <template slot-scope="scope">
                  <div>
                    <el-input-number v-model="scope.row.condition" :min="1" :max="100000000"
                      :precision="0"></el-input-number>
                  </div>
                </template>
              </el-table-column>

              <!-- 抢购和买赠显示活动价格，抢购是商品价格，买赠是减免金额 -->
              <el-table-column v-if="isQG" prop="price" align="center" label="活动价格">
                <template slot-scope="scope">
                  <div>
                    <el-input-number v-model="scope.row.price" :min="0" :max="100000000"
                      :precision="2"></el-input-number>
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="isMJ" prop="price" align="center" label="减免金额">
                <template slot-scope="scope">
                  <div>
                    <el-input-number v-model="scope.row.price" :min="0" :max="100000000"
                      :precision="2"></el-input-number>
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="isDBY" prop="ActPrice" align="center" label="价格">
                <template slot-scope="scope">
                  <div>
                    <el-input-number v-model="scope.row.price" :min="0" :max="100000000"
                      :precision="2"></el-input-number>
                  </div>
                </template>
              </el-table-column>
              <!-- 买赠换购活动按照满足数量促销时，显示赠品数量设置 -->
              <el-table-column v-if="isMZ || isHG || isGHG" prop="price" align="center" label="赠送数量">
                <template slot-scope="scope">
                  <div>
                    <el-input-number v-model="scope.row.gives" :min="1" :max="100000000"
                      :precision="0"></el-input-number>
                  </div>
                </template>
              </el-table-column>

              <el-table-column v-if="isZK" prop="quantity" align="center" label="折扣">
                <template slot-scope="scope">
                  <div>
                    <el-input-number v-model="scope.row.distinct" :min="1" :max="100" :precision="0"></el-input-number>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                  <el-button type="danger" style="padding: 2px 3px" plain @click="handleDelRule(scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>

        <el-divider>控销设置</el-divider>
        <!-- <div class="form-item-wrap">
          <el-form-item label="客户类型" prop="userType">
            <el-checkbox :indeterminate="indeterminate" v-model="checkAll"
              @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="addForm.userType" style="width: 1000px" @change="handleCheckedChange">
              <el-checkbox v-for="item in userTypeList" :key="item.value" :label="item.value">
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="区域控销" prop="limitArea">
            <el-select v-model="addForm.limitArea" placeholder="区域控销" style="width: 200px; margin-right: 5px">
              <el-option label="无限制" value="0"></el-option>
              <el-option label="指定白名单" value="1"></el-option>
              <el-option label="指定黑名单" value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- 这个是之前标签的那种形式，改用级联选择器的形式了 -->
          <!-- <el-form-item v-show="addForm.limitArea != 0" label="选择区域" prop="areaValue">
                                            <div style="width: 800px">
                                              <div>
                                                <el-tag v-for="(item, index) in addForm.areaValue" :key="index" closable @close="onTagClose(index)"
                                                  type="success" effect="dark" :disable-transitions="false" class="my-el-tag"
                                                  style="margin-bottom: 5px">{{ item.label }}
                                                </el-tag>
                                              </div>
                                              <el-button type="primary" @click="areaDialog = true">增加区域</el-button>
                                            </div>
                                          </el-form-item> -->
          <el-form-item v-show="addForm.limitArea != 0" label="选择区域" prop="areaValue">
            <el-cascader ref="areaCascader" style="width: 200px" size="small" v-model="addForm.areaValue"
              :options="areaList" :props="{
                multiple: true,
                checkStrictly: true,
                label: 'CityName',
                value: 'CityCodes',
                children: 'AreaList',
                emitPath: false,
              }" @change="onCascaderChange"></el-cascader>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="客户控销" prop="customerLimit">
            <el-select v-model="addForm.customerLimit" placeholder="请选择" style="width: 200px; margin-right: 5px">
              <el-option label="无限制" value="0"></el-option>
              <el-option label="指定白名单" value="1"></el-option>
              <el-option label="指定黑名单" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="addForm.customerLimit != 0" label="选择分组" prop="customerGroup">
            <el-select v-model="addForm.customerGroup" placeholder="请选择" style="width: 200px" filterable clearable
              multiple>
              <el-option v-for="item in groupList" :key="item.GroupId" :label="item.GroupName" :value="item.GroupId">
              </el-option>
            </el-select>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="标签控销" prop="tagLimit">
            <el-select v-model="addForm.tagLimit" placeholder="请选择" style="width: 200px; margin-right: 5px">
              <el-option label="无限制" value="0"></el-option>
              <el-option label="指定白名单" value="1"></el-option>
              <el-option label="指定黑名单" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="addForm.tagLimit != 0" label="选择标签" prop="tagGroup">
            <el-select v-model="addForm.tagGroup" placeholder="请选择" style="width: 200px" filterable clearable multiple>
              <el-option v-for="item in tagGroupList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="订单类型" prop="orderType">
            <el-checkbox  v-model="addForm.firstOrder" :disabled="addForm.status != 1">首单</el-checkbox>
            <el-checkbox v-model="addForm.reOrder" :disabled="addForm.status != 1" style="margin-left: 10px">复购</el-checkbox>
          </el-form-item>
        </div>

        <el-form-item label="">
          <!-- 禁用状态下显示保存按钮 -->
          <el-button v-if="addForm.status == 1" type="primary" @click="handleSubmitGoods">保存</el-button>
        </el-form-item>
      </el-form>
    </el-scrollbar>

    <!-- 选择数据表格 -->
    <el-dialog title="请选择" :visible.sync="goodsDialog" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="80%">
      <search-bar>
        <template>
          <el-input style="width: 200px; margin-right: 5px" clearable placeholder="输入名称检索" v-model="goodsName"
            @keydown.native.enter="getGoodsList('search')">
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="getGoodsList('search')">搜索</el-button>
        </template>
      </search-bar>
      <el-table :data="goodsList" border tooltip-effect="dark" height="300px" :row-class-name="tableRowClassName">
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column v-for="(value, key) in tableHeader" :key="key" :label="value" prop="code" align="center"
          width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{ scope.row[key] }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="code" align="center" width="160" show-overflow-tooltip label="ERP商品编号">
                                        </el-table-column>
                                        <el-table-column prop="name" align="center" width="160" show-overflow-tooltip label="商品名称">
                                        </el-table-column>
                                        <el-table-column prop="entname" align="center" show-overflow-tooltip label="机构名称">
                                        </el-table-column>
                                        <el-table-column prop="specification" label="商品规格" width="120" align="center" show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column prop="packingNnit" label="包装单位" align="center" show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column prop="producer" label="生产厂家" width="120" align="center" show-overflow-tooltip>
                                        </el-table-column> -->
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" style="padding: 2px 3px" plain @click="handleGoodsItem(scope)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :allPage="allPage2" :pageSize="pageSize2" :currIndex="currPage2" @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"></pagination>
    </el-dialog>

    <!-- 赠品数据列表 -->
    <el-dialog title="请选择" :visible.sync="giftDialog" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="80%">
      <search-bar>
        <template>
          <el-input style="width: 200px; margin-right: 5px" clearable placeholder="输入名称检索" v-model="giftName"
            @keydown.native.enter="getGiftList('search')">
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="getGiftList('search')">搜索</el-button>
        </template>
      </search-bar>
      <el-table :data="giftList" stripe border tooltip-effect="dark" height="300px">
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column v-for="(value, key) in giftTableHeader" :key="key" :label="value" prop="code" align="center"
          width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{ scope.row[key] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" style="padding: 2px 3px" plain @click="handleGiftItem(scope)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :allPage="allPage3" :pageSize="pageSize3" :currIndex="currPage3" @hanSiChange="hanSiChange3"
        @hanCurrChange="hanCurrChange3"></pagination>
    </el-dialog>

    <el-dialog title="操作说明" :visible.sync="explain" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="70%">
      <div class="explain-text">
        <p>买赠活动的赠品在 商品管理 -> 赠品管理中维护</p>
        <p>换购活动的赠品在 商品管理 -> 商品列表中维护 “换购商品数量”</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";
export default {
  name: "promForm",
  data() {
    return {
      /**用户信息 */
      entId: "", //机构id

      /**参数信息 */
      id: "", // 该条数据id
      activityId: "",

      /**批量绑定商品 */
      /**提交表单 */
      addForm: {
        type: "DQG", //活动类型，手动选择，默认了抢购
        title: "", //标题
        coverage: "G01", //商品范围
        userType: [], //选中的用户类型
        isAdd: "N", //是否累加 N/Y
        list: [], //{id、name}//活动商品
        rules: [], //促销满足条件规则
        limitArea: "0", // 区域控销
        areaValue: [], // 选中区域，只有id，没有label，只作为输入框展示
        selectAreaNodes: [], // 选中区域的节点信息，包含label
        customerLimit: "0", //是黑名单还是白名单
        customerGroup: [], //选中客户分组id
        tagLimit: "0", //标签控销
        tagGroup: [], //选中标签分组id
        // orderLimit: "1",//订单类型
        // orderGroup:[],
        firstOrder: false,//订单类型
        reOrder:false,
        startTime: "", //开始时间
        endTime: "", //结束时间
        status: 1, // 1禁用 2启用 0删除，主要用来判断查看或者编辑是否显示保存按钮
        mode: "M02", // 活动满足促销的模式， M01：满足金额 M02：满足数量 M03：满足数量减金额
        describe: "", //促销描述
        totalQuantity: 1, // 组合活动总组数填写
        limitQuantity: 0, // 组合活动限购总数量填写
      },
      addFormRules: {
        type: [mustFill],
        title: [mustFill],
        list: [mustFill],
        startTime: [mustFill],
        endTime: [mustFill],
        coverage: [
          mustFill,
          {
            validator: (rule, value, callback) => {
              //如果商品范围是全部商品，则不需要判断数组是否为空
              if (value != "G04") {
                if (this.addForm.list.length == 0) {
                  callback(new Error("请添加商品"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        mode: [
          mustFill,
          {
            validator: (rule, value, callback) => {
              //如果商品范围是全部商品，则不需要判断数组是否为空
              // if (this.addForm.mode == 'G05') {
              //   // 组合活动不填写促销规则
              //   callback();
              // } else
              if (this.addForm.rules.length == 0) {
                callback(new Error("请添加促销规则"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      }, // 表单规则
      oldType: "DQG", //活动类型选中值备份，用来做确认框使用

      /**商品范围类型列表 */
      coverageList: [
        { label: "独立商品", value: "G01" },
        { label: "分组商品", value: "G02" },
        { label: "品牌商品", value: "G03" },
        { label: "全部商品", value: "G04" },
        { label: "组合商品", value: "G05" },
      ],
      coverageDisabled: true, //选择框禁用状态，有的活动只能指定商品类型，默认是抢购活动，只能选择独立商品，不可调整

      /**区域控销选项数据 */
      areaDialog: false, //dialog状态
      areaList: [],

      /**客户分组选项数据 */
      groupList: [],

      /**客户类型 */
      userTypeList: [],
      checkAll: false, //全选
      indeterminate: false, // 半选状态

      /** 标签分组 */
      tagGroupList: [], //标签分组选项数据

      /**提交表单信息 */
      submitType: "Add", //提交类型，编辑或者新增 Add/Update

      /**商品列表选项数据 */
      goodsName: "", //检索使用，商品名称
      goodsDialog: false, //dialog
      goodsList: [], //查询到的商品列表
      tableHeader: {}, //表头数据，要改成动态表格的形式
      /**商品列表分页数据 */
      currPage2: 1,
      pageSize2: 20,
      allPage2: 0,

      /**赠品数据 */
      giftName: "",
      giftDialog: false,
      giftList: [],
      giftTableHeader: {},
      /**商品列表分页数据 */
      currPage3: 1,
      pageSize3: 20,
      allPage3: 0,

      /**促销满足条件规则相关 */
      selectedRuleIndex: 0, //临时存放操作的规则下标

      /**使用说明 */
      explain: false,
      promtype: [],
      Tyname: "数量", //满足金额，满足数量时，label字段改变
    };
  },
  computed: {
    /**促销类型判断，使用计算属性来代替，能够精简模板，减少臃肿 */
    /**是否抢购 */
    isQG() {
      // 使用oldType才是用户最终选中的类型
      return this.oldType == "DQG";
    },
    /**是否折扣 */
    isZK() {
      return this.oldType == "DZK";
    },
    /**是否买赠 */
    isMZ() {
      return this.oldType == "DMZ";
    },
    /**是否满减 */
    isMJ() {
      return this.oldType == "DMJ";
    },
    /**是否换购 */
    isHG() {
      return this.oldType == "DHG";
    },
    /**是否组合 */
    isZH() {
      return this.oldType == "GZH";
    },
    /**是否特换购 */
    isGHG() {
      return this.oldType == "GHG";
    },
    isDBY() {
      return this.oldType == "DBY";
    },
  },
  mounted() {
    this.getpromType();
    /**参数接收 */
    if ("type" in this.$route.query) {
      this.submitType = this.$route.query.type;
      this.activityId = this.$route.query.id;
      if (this.activityId) {
        this.getData();
      }
    }
    this.entId = window.localStorage.getItem("entId");
    this.getGroupList();
    this.getAreaList();
    this.getUserType();
    this.getTag();
    this.handleAddRule(); //因为默认是抢购，不会触发下拉框change事件，所以默认添加一条规则
  },
  methods: {
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
    },
    /**获取促销分类 */
    getpromType() {
      this.$request({
        url: "/Activity/GetActivityTypeApi",
        method: "post",
        data: {
          activityType: "Promotion",
        },
      })
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.promtype = res.dataList;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**活动类型下拉框change回调 */
    onTypeSelectChange() {
      this.$confirm("将会清空选中商品数据和规则数据，确定切换吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.oldType = this.addForm.type; //确定使用了该类型的活动
          // 清空促销规则
          this.addForm.rules = []; //清除规则
          this.addForm.list = []; //清除商品

          // 这里面做的操作比较多，控制商品范围类型
          if (this.isQG) {
            // 抢购，禁用商品范围按钮，只让选择独立商品
            this.coverageDisabled = true;
            this.addForm.coverage = "G01"; // 商品范围选中为默认商品
            this.handleAddRule(); //随便添加一条规则，后台不会使用
          } else if (this.isZH) {
            this.coverageList = [
              { label: "独立商品", value: "G01" },
              { label: "分组商品", value: "G02" },
              { label: "品牌商品", value: "G03" },
              { label: "全部商品", value: "G04" },
              { label: "组合商品", value: "G05" },
            ];
            // 组合，禁用商品范围按钮，只让选择组合商品
            this.coverageDisabled = true;
            this.addForm.coverage = "G05"; // 商品范围选中为组合商品
            this.handleAddRule(); //随便添加一条规则，后台不会使用
          } else if (this.isGHG) {
            this.coverageList = [
              { label: "独立商品", value: "G01" },
              { label: "分组商品", value: "G02" },
              { label: "品牌商品", value: "G03" },
              { label: "全部商品", value: "G04" },
              { label: "组合商品", value: "G05" },
            ];
            this.coverageDisabled = true;
            this.addForm.coverage = "G05"; // 商品范围选中为组合商品
          } else if (this.isDBY) {
            this.coverageList = [{ label: "独立商品", value: "G01" }];
            this.coverageDisabled = true;
            this.addForm.coverage = "G01"; // 商品范围选中为组合商品
          } else {
            this.coverageDisabled = false;
            this.coverageList = [
              { label: "独立商品", value: "G01" },
              { label: "分组商品", value: "G02" },
              { label: "品牌商品", value: "G03" },
              { label: "全部商品", value: "G04" },
            ];
          }

          // 促销满足条件中的满足模式初始化，因为有的从满减切换到其他活动这个值会不发生改变
          this.addForm.mode = "M02";

          // 规则表格重新绘制，用到了插槽，不重新绘制可能不正常
          this.$refs.rulesTable.doLayout();
        })
        .catch(() => {
          this.addForm.type = this.oldType;
        });
    },

    /**满足模式下拉框change回调 */
    onModeSelectChange(e) {
      // M02是满足数量，从满足价格切换回来可能这个值为浮点数，要把值修改成整数
      if (e == "M01") {
        this.Tyname = "金额";
      } else {
        this.Tyname = "数量";
        this.addForm.rules.forEach((item) => {
          item.condition = parseInt(item.condition);
        });
      }
    },

    /**表格数据选中状态判断 */
    tableRowClassName({ row }) {
      for (let i = 0; i < this.addForm.list.length; i++) {
        let item = this.addForm.list[i];
        if (item.code == row.keyid) {
          return "success-row";
        }
      }

      return "";
    },

    /**商品范围下拉框change回调 */
    onCoverageSelectChange() {
      // 这里面主要做清空addForm.list操作
      this.addForm.list = [];
    },

    /**编辑情况下获取活动详情 */
    getData() {
      let data = {
        activityId: this.activityId,
      };

      this.$request({
        url: "/Management/ActivityAdmin/GetActivityDetail",
        method: "post",
        data,
      })
        .then((res) => {
          if (res.success) {
            // let { Activity, ActivityControl, ActivityGoods,ActivityGifts,ActivityRule } = res.dataModel
            let Activity = res.dataModel.Activity || [];
            let ActivityControl = res.dataModel.ActivityControl || [];
            let ActivityGoods = res.dataModel.ActivityGoods || [];
            let ActivityGifts = res.dataModel.ActivityGifts || [];
            let ActivityRule = res.dataModel.ActivityRule || [];
            this.addForm.title = Activity.Title;
            this.addForm.type = Activity.ActivityType;
            this.oldType = this.addForm.type;
            this.addForm.startTime = Activity.StartTime;
            this.addForm.endTime = Activity.EndTime;
            this.addForm.status = Activity.Status;
            this.addForm.describe = Activity.Describe;
            this.addForm.mode = Activity.ActvScenario;
            if (this.addForm.mode == "M01") {
              this.Tyname = "金额";
            } else {
              this.Tyname = "数量";
            }
            this.addForm.isAdd = Activity.Accumulation;
            this.addForm.coverage = Activity.GoodsCoverage;

            // 做一些界面初始化的操作，必须要放在这，因为要等基本数据赋值后才能做判断
            if (!this.isQG && !this.isZH) {
              // 如果不是抢购活动或者组合活动则商品范围默认可选
              this.coverageDisabled = false;
            }
            if (this.isDBY) {
              // 如果不是抢购活动或者组合活动则商品范围默认可选
              this.coverageDisabled = true;
            }
            ActivityControl.forEach((item) => {
              if (item.LimitType == "Area") {
                this.addForm.limitArea = item.Limit + ""; //变为字符串
                // 之前tags的方式
                // this.addForm.areaValue.push({
                //   label: item.LimitName,
                //   value: item.LimitCode
                // })
                this.addForm.areaValue.push(item.LimitCode);
              } else if (item.LimitType == "Client") {
                this.addForm.customerLimit = item.Limit + ""; //变为字符串
                this.addForm.customerGroup.push(parseInt(item.LimitCode)); //返回的数据是int类型
              } else if (item.LimitType == "ClientType") {
                this.addForm.userType.push(item.LimitCode);
              } else if (item.LimitType == "Tage") {
                this.addForm.tagLimit = item.Limit + ""; //变为字符串
                this.addForm.tagGroup.push(parseInt(item.LimitCode)); //返回的数据是int类型
              } else if (item.LimitType == "OrderType") {
                if (item.LimitCode == "首单") {
                  this.addForm.firstOrder = true;
                } else if (item.LimitCode == "复购") {
                  this.addForm.reOrder = true;
                }
              }
            });

            this.addForm.list = ActivityGoods.map((item) => {
              // 组合活动需要，不加条件判断也行，因为提交方法中加的有
              this.addForm.totalQuantity = item.TotalQuantity;
              this.addForm.limitQuantity = item.ClientQuantity;

              return {
                id: item.Id,
                code: item.GoodsId,
                title: item.GoodsName,
                quantity: item.Quantity, // 起购数量
                price: item.Price,
                discount: item.Discount,
                limitNum: item.ClientQuantity, //限购数量
                totalQuantity: item.TotalQuantity, //商品总数量
              };
            });
            // 处理买赠数据
            ActivityRule.forEach((item, i) => {
              item.condition = item.Conditions; //满足条件
              item.price = item.ActPrice; // 活动价格
              item.distinct = item.ActDistinct; // 活动折扣
              item.gives = item.ActQuantity; // 赠送数量
              item.giftList = [];
              ActivityGifts.forEach((item2) => {
                if (item.SortId == item2.RuleSortId) {
                  // 规则SortId和RuleSortId相同时，赠品数据才对
                  item.giftList.push({
                    goodsname: item2.GiftName,
                    goodscode: item2.GoodsId,
                    quantity: parseInt(item2.StockQuantity), // 这个是原来的数量，用来做限制
                    num: parseInt(item2.Quantity),
                    price: item2.Price, //赠品价格默认0
                    RuleSortId: item2.RuleSortId,
                    goodsType: item2.GoodsType,
                    ruleIndex: i, //促销规则的排序值，没有+1是因为保存的时候会+1
                  });
                }
              });
            });
            this.addForm.rules = ActivityRule;
            console.log(this.addForm.rules, "数据");
            // this.addForm.rules = ActivityRule.map((item, i) => {
            //   return {
            //     condition: item.Conditions, //满足条件
            //     price: item.ActPrice, // 活动价格
            //     distinct: item.ActDistinct, // 活动折扣
            //     gives: item.ActQuantity, // 赠送数量
            //     giftList: ActivityGifts.map((item2) => {
            //       return {
            //         goodsname: item2.GiftName,
            //         goodscode: item2.GoodsId,
            //         quantity: parseInt(item2.Quantity), // 这个是原来的数量，用来做限制
            //         num: parseInt(item2.Quantity),
            //         // price: row.price_ck,
            //         price: item2.Price, //赠品价格默认0
            //         ruleIndex: i, //促销规则的排序值，没有+1是因为保存的时候会+1
            //       };
            //     }),
            //   };
            // });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /************ 获取商品列表 ****************/
    /**点击打开数据选择框 */
    handleChoose() {
      // 获取数据
      this.goodsDialog = true;
      this.getGoodsList("refresh");
    },

    /**获取商品数据 */
    getGoodsList(load = "") {
      // 需要根据选择的商品范围来判断获取不同的数据
      if (load == "refresh") {
        this.currPage2 = 1;
        this.goodsName = "";
      } else if (load == "search") {
        this.currPage2 = 1;
      }

      let data = {
        type: "",
        PageIndex: this.currPage2,
        PageSize: this.pageSize2,
        strWhere: this.goodsName,
      };

      if (this.addForm.coverage == "G01" || this.addForm.coverage == "G05") {
        //独立商品
        data.type = "GoodsList";
      } else if (this.addForm.coverage == "G02") {
        //分组商品
        this.getGoodsGroup(); //获取商品分组
        return;
      } else if (this.addForm.coverage == "G03") {
        // 品牌商品
        data.type = "goodsBrand";
      } else if (this.addForm.coverage == "G04") {
        // 全部商品就不需要获取了
        return;
      }

      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsList = res.content;
            this.tableHeader = res.fdname;
            this.allPage2 = res.recordCount;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });

      // let data = {
      //   type: "GoodsList",
      //   category: "0",
      //   attribute: "0",
      //   status: "2",
      //   strWhere: this.goodsName,
      //   PageIndex: this.currPage2,
      //   PageSize: this.pageSize2,
      //   promtype: "",
      //   promstatus: "99",
      //   goodsPic: "99",
      //   spStatus: "99",
      // };
      // let proc = "Proc_Admin_GoodsList"; // 存储过程名
      // let type = "ReturnList";
      // this.$requestSys({
      //   url:
      //     "goods/ashx/ReturnJson.ashx?type=" +
      //     type +
      //     "&json=" +
      //     encodeURIComponent(JSON.stringify(data)) +
      //     "&proc=" +
      //     proc,
      //   method: "post",
      // })
      //   .then((res) => {
      //     this.allPage2 = res.recordCount;
      //     this.goodsList = [];
      //     if (res.flag == 0) {
      //       for (let i = 0; i < res.data.length; i++) {
      //         this.goodsList.push({
      //           articleId: res.data[i].article_id,
      //           code: res.data[i].goodscode,
      //           name: res.data[i].sub_title,
      //           entname: res.data[i].entname,
      //           entid: res.data[i].entId,
      //           specification: res.data[i].drug_spec,
      //           packingNnit: res.data[i].package_unit,
      //           producer: res.data[i].drug_factory,
      //           classify: res.data[i].category,
      //           repertory: res.data[i].stock_quantity,
      //           retailPrice: res.data[i].price,
      //           validTime: res.data[i].valdate,
      //           organId: res.data[i].adminentid,
      //           status: res.data[i].status,
      //           sort: res.data[i].sort_id,
      //         });
      //       }
      //     }
      //   })
      //   .catch((err) => {
      //     window.console.log(err);
      //   });
    },

    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getGoodsList();
    },

    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getGoodsList();
    },

    /**获取商品分组功能 */
    getGoodsGroup() {
      let data = {
        type: "GetPromGoodsGroup",
        status: 2,
        strWhere: "",
        PageIndex: 1,
        PageSize: 99,
      };
      let proc = "Proc_PromGoodsGroup"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "prom/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableHeader = {
            GroupName: "分组名称",
            GoodsCount: "商品数量",
            addTime: "创建时间",
          };

          if (res.flag == 0) {
            this.goodsList = res.data;
            this.allPage2 = res.recordCount;
          } else {
            // 表格清空，提示无数据
            this.goodsList = [];
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**选中某一个条数据 */
    handleGoodsItem({ row }) {
      let obj = {
        code: row.keyid,
        title: row.sub_title,
        id: "", //这个字段编辑的时候后端会返回，添加的时候默认空
        quantity: 1, //活动数量
        price: 0, //价格
        discount: 100, //折扣
        limitNum: 0, //限购数量
        totalQuantity: 1, //总数量，一般组合用
        goodscode: row.goodscode,
        drug_spec: row.drug_spec,
        drug_factory: row.drug_factory,
      };
      // 根据商品选择的范围，来执行操作
      if (this.addForm.coverage == "G01") {
        // 判断数组中是否存该条数据
        // let repeat = this.addForm.list.some((item) => item.articleId == row.articleId);
        // if (repeat) {
        //   this.$message({
        //     message: "该商品已存在",
        //     type: "warning",
        //   });
        // } else {
        //   this.$message({
        //     message: "添加成功",
        //     type: "success",
        //     duration: 1000,
        //   });
        // }

        // 抢购活动允许添加多条，其他的活动添加数据后就关闭dialog，并且不允许添加多条
        if (this.addForm.list.length > 0 && !this.isQG) {
          this.goodsDialog = false;
          return;
        }

        obj.code = row.keyid;
        obj.title =
          row.sub_title +
          "(" +
          row.goodscode +
          "-" +
          row.drug_spec +
          "-库存:" +
          row.stock_quantity +
          "-" +
          row.drug_factory +
          ")";
        obj.goodscode = row.goodscode;
        obj.drug_spec = row.drug_spec;
        obj.drug_factory = row.drug_factory;
        this.addForm.list.push(obj);
      } else if (this.addForm.coverage == "G02") {
        //分组商品，这里面没有进行数据过滤是因为在提交的时候进行过滤
        obj.code = row.GroupId;
        obj.title = row.GroupName;
        this.addForm.list.push(obj);
        this.goodsDialog = false;
      } else if (this.addForm.coverage == "G03") {
        // 品牌商品
        obj.code = row.billno;
        obj.title = row.name;
        this.addForm.list.push(obj);
        this.goodsDialog = false;
      } else if (this.addForm.coverage == "G05") {
        // 组合商品
        obj.code = row.keyid;
        obj.title =
          row.sub_title +
          "(" +
          row.goodscode +
          "-" +
          row.drug_spec +
          "-库存:" +
          row.stock_quantity +
          "-";
        row.drug_factory + ")";
        this.addForm.list.push(obj);
        this.goodsDialog = false;
      }
      // else if (this.addForm.coverage == 'G04') {
      //   // 全部商品就不需要获取了
      //   return
      // }
    },

    /**删除选中的某一个商品 */
    handleDelGoods({ $index }) {
      this.addForm.list.splice($index, 1);
    },

    /************ 赠品管理的操作 ****************/
    handleChooseGift({ $index }) {
      this.selectedRuleIndex = $index; //规则的临时下标
      // 把数据清空，获取数据
      this.giftDialog = true;
      this.getGiftList("refresh");
    },

    /**获取赠品数据 */
    getGiftList(load = "") {
      // 需要根据选择的商品范围来判断获取不同的数据
      if (load == "refresh") {
        this.currPage3 = 1;
        this.giftName = "";
      } else if (load == "search") {
        this.currPage3 = 1;
      }

      let giftType = "";
      if (this.oldType == "DHG") {
        giftType = "GoodsListHG";
      } else if (this.oldType == "DMZ") {
        giftType = "GoodsListMZ";
      } else if (this.oldType == "GHG") {
        giftType = "GoodsListHG";
      }

      let data = {
        type: giftType,
        PageIndex: this.currPage3,
        PageSize: this.pageSize3,
        strWhere: this.giftName,
      };

      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.giftList = res.content;
            this.giftTableHeader = res.fdname;
            this.allPage3 = res.recordCount;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange3(val) {
      this.pageSize3 = val;
      this.getGiftList();
    },

    /**当前页改变 */
    hanCurrChange3(val) {
      this.currPage3 = val;
      this.getGiftList();
    },

    /**选中某一个条数据 */
    handleGiftItem({ row }) {
      let goods = row.goodscode;
      // 换购和买赠返回的数据不一样，字段名也不一样，这里区别判断
      let obj = null;
      if (this.oldType == "DHG") {
        obj = {
          goodsname:
            row.sub_title +
            "-（" +
            goods +
            // "-" +
            // row.drug_spec +
            // "-" +
            // row.drug_factory +
            ")",
          goodscode: row.keyid, //去除空格
          quantity: parseInt(row.stock_quantity), // 这个是原来的数量，用来做限制
          num: parseInt(row.stock_quantity),
          // price: row.price_ck,
          price: 0, //赠品价格默认0
          ruleIndex: this.selectedRuleIndex, //促销规则的排序值
          goodsType: row.goodsType,
        };
      } else if (this.oldType == "DMZ") {
        obj = {
          goodsname:
            row.goodsname +
            "-（" +
            goods +
            // "-" +
            // row.drug_spec +
            // "-" +
            // row.drug_factory + "-" +
            ")",
          goodscode: row.keyid, //去除空格
          quantity: parseInt(row.quantity), // 这个是原来的数量，用来做限制
          num: parseInt(row.quantity),
          goodsType: row.goodsType,
          // price: row.price_ck,
          price: 0, //赠品价格默认0
          ruleIndex: this.selectedRuleIndex, //促销规则的排序值
        };
      } else if (this.oldType == "GHG") {
        obj = {
          goodsname:
            row.sub_title +
            " -（" +
            goods +
            // " - " +
            // row.drug_spec +
            // " - " +
            // row.drug_factory +
            ")",
          goodscode: row.keyid, //去除空格
          quantity: parseInt(row.quantity), // 这个是原来的数量，用来做限制
          num: parseInt(row.quantity),
          goodsType: row.goodsType,
          // price: row.price_ck,
          price: 0, //赠品价格默认0
          ruleIndex: this.selectedRuleIndex, //促销规则的排序值
        };
      }

      // 重复数据判断
      let have = this.addForm.rules[this.selectedRuleIndex].giftList.some(
        (item) => item.goodscode == obj.goodscode
      );
      if (have) {
        this.$message({
          message: "已存在！",
          type: "warning",
        });
        return;
      }

      this.addForm.rules[this.selectedRuleIndex].giftList.push(obj);
      this.giftDialog = false;
    },

    /**删除选中的某一个赠品 */
    handleDelGift(scope, scope2) {
      // console.log(scope,scope2);
      this.addForm.rules[scope.$index].giftList.splice(scope2.$index, 1);
    },

    /************ 获取区域列表 ****************/
    getAreaList() {
      this.$request({
        method: "post",
        url: "/Base/GetTreeAreaListApi",
      })
        .then((res) => {
          if (res.success) {
            this.areaList = res.dataList || [];
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**cascader change回调 */
    onCascaderChange() {
      this.addForm.selectAreaNodes =
        this.$refs["areaCascader"].getCheckedNodes(); //获取选中的节点信息，主要是获取value和label
    },

    /************ 客户控销方法 ****************/
    /**获取客户列表 */
    getGroupList() {
      let data = {
        entId: this.entId,
        status: "2",
        searchVal: "", //关键字
        pageIndex: 1,
        pageSize: 999,
      };

      this.$request({
        url: "Member/GetMemberGroup",
        method: "post",
        data,
      })
        .then((res) => {
          this.groupList = res.list;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**客户类型获取 */
    getUserType() {
      let data = {
        type: "CustomType",
      };
      let proc = "Proc_Admin_CustomerList"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.userTypeList = res.data.map((item) => {
              return {
                label: item.clienttype,
                value: item.TypeID,
              };
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**标签获取 */
    getTag() {
      let data = {
        entId: window.localStorage.getItem("entId"),
        id: '',
        channel_id: 21, //客户标签
        title: '',
        parent_id: '',
        class_layer: '',
        sort_id: '',
        link_url: '',
        img_url: '',
        pageIndex: 1,
        pageSize: 20,
        toTal: '',
        sqlValue: '',
        keyId: 0,
      };
      this.$request({
        method: 'post',
        url: 'Base/GetTableCategory',
        data: data,
      }).then(res => {
        console.log('获取标签数据',res);
        this.tagGroupList = []
        this.allPage = 0
        if(res.success){
          this.allPage = res.toTal
          this.tagGroupList = (res.list || []).map(item => ({
            id: item.Id, // 编号  
            // channel_id: item.channel_id || 21 , // 客户标签编号
            title: item.title || '', // 客户标签名称
            sort_id: item.sort_id || '', // 排序
          }))
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },


    /**全选 */
    handleCheckAllChange(val) {
      // 根据val的值判断是否全选
      if (val) {
        this.addForm.userType = this.userTypeList.map((item) => item.value);
      } else {
        this.addForm.userType = [];
      }
    },

    handleCheckedChange(val) {
      // 判断选中的数据是否半选或者全选
      this.checkAll = val.length === this.userTypeList.length;
      this.indeterminate =
        val.length > 0 && val.length < this.userTypeList.length;
    },

    /************ 促销规则方法 ****************/
    handleAddRule() {
      this.addForm.rules.push({
        condition: 0, //满足
        price: 0, //活动价
        distinct: 100, //折扣
        gives: 1, // 赠品赠送数量
        giftList: [], //如果是买赠的话存赠品
      });
    },

    /**删除某一条规则 */
    handleDelRule({ $index }) {
      this.addForm.rules.splice($index, 1);
    },

    /************ 提交促销数据 ****************/
    /**提交促销数据 */
    handleSubmitGoods() {
      // if (this.addForm.list.length == 0) {
      //   this.$message({
      //     message: "请添加活动商品",
      //     type: "error",
      //   });
      //   return;
      // }

      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          /**促销规则 */
          let ActivityRule = [];
          /**商品数据 */
          let ActivityGoods = [];
          /**赠品/换购商品，从规则数组中取 */
          let ActivityGifts = [];

          this.addForm.list.forEach((item, i) => {
            // 独立商品
            ActivityGoods.push({
              // Id: item.id ? item.id : 0,//传商品中的数据，有的话传，没的话传0
              Id: 0, //传商品中的数据，有的话传，没的话传0
              ActivityId: this.activityId, // 传该条活动的id
              SortId: i + 1, //序号从1开始
              GoodsId: item.code, //商品id
              GoodsName: item.title, // 商品名称
              Price: this.isZK ? this.addForm.rules[0].price : item.price, //价格，如果是折扣的话，从规则中取出来活动价格，后端省查询流程
              Discount: this.isZK
                ? this.addForm.rules[0].distinct
                : item.discount, //折扣
              Quantity: item.quantity,
              TotalQuantity: this.isZH
                ? this.addForm.totalQuantity
                : item.totalQuantity, // 总数量，如果是组合活动的话，是通过addForm.totalQuantity字段控制的，其他的使用
              ClientQuantity: this.isZH
                ? this.addForm.limitQuantity
                : item.limitNum, //客户限购数量
            });
          });

          this.addForm.rules.forEach((item, i) => {
            ActivityRule.push({
              // ActRuleId: item.id ? item.id : 0,//传商品中的数据，有的话传，没的话传0
              ActRuleId: 0, //传商品中的数据，有的话传，没的话传0
              ActivityId: this.activityId, // 传该条活动的id
              SortId: i + 1,
              Conditions: item.condition, //满足条件
              ActPrice: item.price, // 活动价
              ActDistinct: item.distinct, //折扣
              ActQuantity: item.gives, // 赠品赠送数量
            });

            item.giftList.forEach((item2) => {
              ActivityGifts.push({
                ActGiftId: 0, //
                ActivityId: this.activityId, //
                ActRuleId: 0, //
                RuleSortId: item2.ruleIndex + 1, //规则下标
                GoodsId: item2.goodscode.trim(), //商品code，去一下空格
                GiftName: item2.goodsname,
                GiftCode: item2.goodscode.trim(),
                Price: item2.price, //赠品价格
                Quantity: item2.num, // 赠品数量
                // GoodsType: this.isHG ? "GT1" : "GT2", //GT1换购传 GT2买赠传
                GoodsType: item2.goodsType,
              });
            });
          });
          /**控销数据 */
          let ActivityControl = [];
          // 区域
          if (this.addForm.limitArea != 0) {
            // 使用这个方法，在编辑的时候数据获取不到默认数据
            // this.addForm.selectAreaNodes.forEach(item => {
            this.addForm.areaValue.forEach((item) => {
              ActivityControl.push({
                // Id: item.Id ? item.Id : 0,//该条数据中的id，这个是后台生成的
                Id: 0, //该条数据中的id，这个是后台生成的
                ActivityId: this.activityId, //
                LimitType: "Area", //Area/Client
                Limit: this.addForm.limitArea,
                LimitCode: item,
                LimitName: item,
                // LimitCode: item.value,
                // LimitName: item.label
              });
            });
          }

          // 客户分组控销
          if (this.addForm.customerLimit != 0) {
            this.addForm.customerGroup.forEach((item) => {
              ActivityControl.push({
                // Id: item.Id ? item.Id : '',//该条数据中的id
                Id: 0, //该条数据中的id
                ActivityId: this.activityId, //
                LimitType: "Client", //Area/Client
                Limit: this.addForm.customerLimit,
                LimitCode: item,
                LimitName: "", //前端通过id就可显示出名称，这里就不传了
              });
            });
          }
          //客户类型控销
          this.addForm.userType.forEach((item) => {
            ActivityControl.push({
              Id: 0, //该条数据中的id
              ActivityId: this.activityId, //
              LimitType: "ClientType", //Area/Client/ClientType
              Limit: 1, // 默认白名单
              LimitCode: item,
              LimitName: "", //前端通过id就可显示出名称，这里就不传了
            });
          });

          //标签类型控销
          if (this.addForm.tagLimit != 0) {
            this.addForm.tagGroup.forEach((item) => {
              const tagObj = this.tagGroupList.find(tag => tag.id == item);
              ActivityControl.push({
                // Id: item.Id ? item.Id : '',//该条数据中的id
                Id: 0, //该条数据中的id
                ActivityId: this.activityId, //
                LimitType: "Tage", //Area/Client
                Limit: this.addForm.tagLimit,
                LimitCode: tagObj.id,
                LimitName: tagObj.title, 
              });
            });
          }

          //订单类型
          // ActivityControl.push({
          //   Id: 0, //该条数据中的id
          //   ActivityId: this.activityId, //
          //   LimitType: "OrderType",
          //   Limit: 1,
          //   LimitCode: this.addForm.orderType,
          //   LimitName: this.addForm.orderType,
          // });
          // 首单
          if (this.addForm.firstOrder) {
            ActivityControl.push({
              Id: 0,
              ActivityId: this.activityId,
              LimitType: "OrderType",
              Limit: 1,
              LimitCode: "首单",
              LimitName: "首单",
            });
          }

          // 复购
          if (this.addForm.reOrder) {
            ActivityControl.push({
              Id: 0,
              ActivityId: this.activityId,
              LimitType: "OrderType",
              Limit: 1,
              LimitCode: "复购",
              LimitName: "复购",
            });
          }


          let data = {
            EditType: this.submitType, //提交类型，编辑或者新增 Add/Update
            Activity: {
              EntId: this.entId, //机构Id
              ActivityId: this.activityId, // 编辑传入id
              Title: this.addForm.title, //标题
              ActivityType: this.oldType, //活动类型
              StartTime: this.addForm.startTime, //开始时间
              EndTime: this.addForm.endTime, //结束时间
              Accumulation: this.addForm.isAdd, //是否累加
              GoodsCoverage: this.addForm.coverage, //商品范围
              ActvScenario: this.addForm.mode, // 满足模式
              Describe: this.addForm.describe,
            },
            ActivityGoods: ActivityGoods, //活动商品信息
            ActivityControl: ActivityControl,
            ActivityGifts: ActivityGifts, //促销规则
            ActivityRule: ActivityRule, //赠品/换购商品，不能为空数组，组合活动一般不传规则
          };
          console.log(data, "数据");
          this.$confirm("确定提交吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$request({
              method: "post",
              url: "/Management/ActivityAdmin/SaveActivityApi",
              data: data,
            })
              .then((res) => {
                let type = "success";
                if (res.success) {
                  // 返回后需要存一个标识，让列表界面刷新一下数据
                  window.localStorage.setItem("refresh", true);
                  this.goBack();
                } else {
                  type = "error";
                }

                this.$message({
                  message: res.message,
                  type,
                });
              })
              .catch((err) => {
                window.console.log(err);
              });
          });
        } else {
          this.$message({
            message: "请补全表单信息!",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style lang='css' scoped>
.promForm {
  width: 100%;
  height: 100%;
}

/******************* 过渡动画 *******************/
.list-move,
/* 对移动中的元素应用的过渡 */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

/* 确保将离开的元素从布局流中删除
  以便能够正确地计算移动的动画。 */
.list-leave-active {
  position: absolute;
}
</style>